import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import Icon from 'componentsV2/Icon';
import Badge from 'componentsV2/Badge';
import Description from 'componentsV2/Description';
import ProgressBar from 'componentsV2/ProgressBar';
import Headline from 'componentsV2/Headline';
import style from './MobileInfo.module.scss';

const MobileInfo = ({
  badgeProps,
  description,
  isPlayable,
  item,
  progressProps,
  showDescription,
  showTitle,
  theme,
  timeLeft,
  title,
  url,
}) => {
  const endDate = progressProps?.endDate;
  const startDate = progressProps?.startDate;
  const isContinueWatching = progressProps?.isContinueWatching;

  return (
    <>
      <div
        className={classNames([
          style.mobileInfo,
          (!showTitle || (showTitle && !title)) &&
            (!showDescription || (showDescription && !description)) &&
            style.playButtonRight,
        ])}
      >
        {showTitle && <Headline theme={theme} text={title} />}
        {showDescription && <Description theme={style} description={description} />}
        {isPlayable && (
          <Link className={style.playIcon} to={url}>
            <Icon icon="play-circle" />
          </Link>
        )}
      </div>
      <div className={style.mobileProgress}>
        {isContinueWatching ? (
          <span className={style.timeLeft}>TIME LEFT · {timeLeft}M</span>
        ) : (
          <Badge theme={style} {...badgeProps} />
        )}
        {isContinueWatching || (startDate && endDate) ? (
          <ProgressBar {...progressProps} theme={style} />
        ) : null}
      </div>
    </>
  );
};

MobileInfo.propTypes = {
  badgeProps: PropTypes.shape({}),
  description: PropTypes.string,
  isPlayable: PropTypes.bool,
  item: PropTypes.shape({}),
  progressProps: PropTypes.shape({}),
  showDescription: PropTypes.bool,
  showTitle: PropTypes.bool,
  theme: PropTypes.shape({}),
  timeLeft: PropTypes.number,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default MobileInfo;
